import { Card, Spin } from "antd";
import { markMessageAsRead } from "api/services/MessageService";
import { TWebDMessage } from "api/services/models/message.types";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import utc from 'dayjs/plugin/utc';
import { useLayoutContext } from "components/MainContainer";

dayjs.extend(utc);

const makeFields = (webdMessage: TWebDMessage) => {
  return [
    {
      key: "1",
      columns: [
        {
          key: 1,
          size: 8,
          value: "From:"
        },
        {
          key: 2,
          size: 16,
          value: `${webdMessage.fromUserId}@${webdMessage.fromAccountId}`
        }
      ]
    },
    {
      key: "2",
      columns: [
        {
          key: 1,
          size: 8,
          value: "To:"
        },
        {
          key: 2,
          size: 16,
          value: `${webdMessage.toUserId}@${webdMessage.toAccountId}`
        }
      ]
    },
    {
      key: "3",
      columns: [
        {
          key: 1,
          size: 24,
          value: `${webdMessage.messageText}`
        }
      ]
    }
  ];
};

const MessageViewer = ({
  message,
  onMessageRead
}: {
  message: TWebDMessage;
  onMessageRead: (message: TWebDMessage) => void;
}) => {
  const { webDUser } = useTDAuthentication();
  const [loading, setLoading] = useState(false);
  const { toggleDrawer, isSmallScreen } = useLayoutContext();

  useEffect(() => {
    if (
      message.messageId &&
      !message.isRead &&
      webDUser?.user.accountId === message.toAccountId &&
      webDUser?.user.userId === message.toUserId
    ) {
      setLoading(true);
      markMessageAsRead(message.messageId)
        .then(r => onMessageRead(message))
        .finally(() => setLoading(false));
    }
  }, [message]);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", !isSmallScreen);
  }, [isSmallScreen]);

  return (
    <>{!isSmallScreen ? (
      <Card
      styles={{body:{padding:"1rem"}}}
        style={{
          minWidth: "33.75rem",
          minHeight: "39.0625rem",
          textAlign: "left"
        }}
        className="card-style">
      {loading ? (
        <Spin />
      ) : (
        <>
        <Card
        styles={{body:{padding:"1rem"}}}
          style={{
            textAlign: "left",
            background: "#FAFAFA",
            border: "none",
            borderRadius: ".75rem",
            marginBottom:"1.25rem"
          }}>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              marginBottom: "1rem"
            }}>
            Info
          </span>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              From:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
              {message.fromAccountId}@{message.fromAccountId}
            </span>
          </div>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              To:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
            {message.toAccountId}@{message.toAccountId}
            </span>
          </div>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              Date, Time:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
            {dayjs.utc(message.createdDatetime).local().format("MM/DD/YYYY, hh:mm:ss A")}
            </span>
          </div>
        </Card>
        <Card
          styles={{body:{padding:"1rem"}}}  
          style={{
            textAlign: "left",
            background: "#FAFAFA",
            border: "none",
            borderRadius: ".75rem",
            height:"26rem"
          }}>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              paddingBottom: "1rem"
            }}>
            Message
          </span>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              paddingBottom: "1rem"
            }}>
            {message.messageText}
          </span>
        </Card>
        </>
        )}</Card>):(
          <>
          <Card
        styles={{body:{padding:"1rem"}}}
          style={{
            textAlign: "left",
            background: "#3A86FF33",
            border: "none",
            borderRadius: ".75rem",
            marginBottom:"1.25rem"
          }}>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              marginBottom: "1rem"
            }}>
            Info
          </span>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              From:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
              {message.fromAccountId}@{message.fromAccountId}
            </span>
          </div>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              To:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
            {message.toAccountId}@{message.toAccountId}
            </span>
          </div>
          <div style={{ fontSize: ".75rem !important", marginBottom:".63rem" }}>
            <span
              className="font-777"
              style={{ display: "inline", fontSize: ".75rem", marginRight:".25rem" }}>
              Date, Time:
            </span>
            <span className="font-1212" style={{  display: "inline", fontSize: ".75rem" }}>
            {dayjs.utc(message.createdDatetime).local().format("MM/DD/YYYY, hh:mm:ss A")}
            </span>
          </div>
        </Card>
        <Card
          styles={{body:{padding:"1rem"}}}  
          style={{
            textAlign: "left",
            background: "#FAFAFA",
            border: "none",
            borderRadius: ".75rem",
            height:"fit-content",
          }}>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              paddingBottom: "1rem"
            }}>
            Message
          </span>
          <span
            className="font-1212"
            style={{
              fontSize: "0.875rem",
              paddingBottom: "1rem"
            }}>
            {message.messageText}
          </span>
        </Card>
        </>
        )}</>
  );
};

export default MessageViewer;
